<template>
  <section v-if="days && Object.keys(days).length">
    <el-row
      v-for="(d, i) in days"
      :key="i"
      type="flex"
      align="top"
      class="infogr-day"
    >
      <el-col :span="12">
        <p>Даты погрузок:</p>
        <p v-if="d.dates.length">
          <span v-for="(date, i) in d.dates" :key="i">
            {{ prepareDate(date, i, d.dates.length) }}
          </span>
        </p>
        <p v-else>нет будующих</p>
      </el-col>
      <el-col :span="12" class="subscribe">
        <p>Цена перевозки:</p>
        <p class="price-vip">
          <span>
            {{ d.prices.price_not_subscribed }}
          </span>
          р/кг
        </p>
      </el-col>
    </el-row>
  </section>
</template>

<script>
export default {
  name: 'DaysInfo',
  props: {
    days: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    prepareDate(date, i = 0, length = 1) {
      const arr = date.split('-')
      const sep = i + 1 < length ? ', ' : ''

      return `${arr[2]}.${arr[1]}${sep}`
    },
  },
}
</script>

<style lang="sass">
.infogr-day
  margin-bottom: 10px
  font-size: 20px
  font-weight: bold
  .subscribe
    p
      text-align: right
    .price-vip
      color: #00B754
      margin: -5px 0 0
      span
        font-size: 40px
</style>
